document.addEventListener("DOMContentLoaded", async function() {
  const cartTemplate = document.querySelector(".template-cart")
  const routesHTML = localStorage.getItem('buyerRoutesHTML') || ''
  const buyerSelection = document.querySelector(".buyer_selection")

  if (cartTemplate && routesHTML && buyerSelection) buyerSelection.insertAdjacentHTML('beforeend', routesHTML)

  if (CID2) {
    if (cartTemplate) await getBasket()

    await getCartsCount()
    await checkIfCartNeedsFlush()
    routeSelected()

    const checkout = document.querySelector("#checkout")

    if (checkout) {
      checkout.addEventListener("click", async function(e) {
        e.preventDefault()
        e.stopPropagation()

        const data =  JSON.parse(
          localStorage.getItem("selectedAgentData")
        )
        
        const buyer = Array.isArray(data) ? data[0] : {}
        const attributes = {}

        Object.entries(buyer).map(([key, value]) => attributes[key] = value ?? "none")

        await updateCartAttributes(attributes)
        await checkoutCart()
      })
    }

    const clearCartBtn = document.querySelector(".clear_cart_btn")
    clearCartBtn?.addEventListener("click", () => flushCart())
  }
})

function getCartsCount(totalParam, basketParam, flyerParam){
  if (!CID2) return

  const updateCart = (basket, promo, total) => {
    const cartProductsCount = document.querySelector(".cart-products-count")

    if (cartProductsCount) {
      cartProductsCount.setAttribute("data-basket", basket)
      cartProductsCount.setAttribute("data-flyer", promo)
      cartProductsCount.innerText = total
    }
  }

  if (!totalParam) {
    fetch(`${ENDPOINT}?action=marvanejo_get_carts_count&customer=${CID2}&store=0`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`${res.status} ${res.statusText}`)
        }

        return res.json()
      })
      .then((data) => {
        const {
          status,
          basket,
          promo,
          total,
          msg
        } = data

        if (Number(status)) {
          updateCart(basket, promo, total)
        } else {
          showLoadingModal(msg)
        }
      })
      .catch((error) => {
        console.error(error)
        showLoadingModal("Erro de comunicação! Tente novamente.")
      })
      .finally(() => removeLoadingModal())
  } else {
    updateCart(basketParam, flyerParam, totalParam)
  }
}

async function checkoutCart() {
  if (typeof CID2 === 'undefined' || CID2 === null) return;

  try {
    showLoadingModal("A carregar checkout...");

    // 1) Chamada à API
    const apiResp = await fetch(ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Accept": "application/json"
      },
      body: new URLSearchParams({
        action: "marvanejo_checkout",
        store: 0,
        customer: CID2
      }).toString(),
      credentials: "same-origin"
    });
    if (!apiResp.ok) throw new Error(`${apiResp.status} ${apiResp.statusText}`);

    const data = await apiResp.json();
    if (Number(data?.status) !== 1) throw new Error(data?.message || "Falha no checkout API");

    const coupon = data?.code;
    const total_with_discount = data?.total_with_discount;

    // 2) Preparar items à maneira do teu jQuery
    const products = Array.isArray(data?.products) ? data.products : [];
    if (!products.length) throw new Error("API sem products.");

    const items = products.map((p, idx) => {
      const variantId = p?.variants?.[0]?.id;
      if (!variantId) return null;

      // propriedades vêm de data.lines[product.id]
      const props = data?.lines ? data.lines[p?.id] : undefined;

      return {
        id: String(variantId),
        quantity: 1,
        properties: (props && typeof props === "object") ? props : undefined
      };
    }).filter(Boolean);

    if (!items.length) throw new Error("Sem variantes válidas.");

    // 3) Limpar carrinho
    await fetch("/cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin"
    });

    // 4) Enviar items como x-www-form-urlencoded (igual ao jQuery)
    const form = new URLSearchParams();
    items.forEach((it, i) => {
      form.append(`items[${i}][id]`, it.id);
      form.append(`items[${i}][quantity]`, String(it.quantity));
      if (it.properties) {
        for (const [k, v] of Object.entries(it.properties)) {
          form.append(`items[${i}][properties][${k}]`, String(v));
        }
      }
    });

    const addResp = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Accept": "application/json"
      },
      credentials: "same-origin",
      body: form.toString()
    });

    if (!addResp.ok) {
      const t = await addResp.text();
      throw new Error(`Falha a adicionar: ${addResp.status} ${addResp.statusText} - ${t}`);
    }

    // 5) Redireção (com cupão, se existir)
    if (coupon) {
      window.location.href = `/discount/${encodeURIComponent(coupon)}?redirect=/checkout`;
    } else {
      window.location.href = "/checkout";
    }
  } catch (err) {
    console.error(err);
    showLoadingModal(err?.message || "Erro de comunicação! Tente novamente.");
  } finally {
    removeLoadingModal();
  }
}


function debounce(func, wait) {
  let timeout
  return function (...args) {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => func.apply(context, args), wait)
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const textareaNote = document.querySelector('textarea[name="attributes[note]"]')
  textareaNote?.addEventListener("input", debounce((e) => {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ note: e.target.value })
    })
      .then(console.log)
      .catch(console.error)
  }, 800))
})

function flushCart() {
  if (!CID2) return

  showLoadingModal("A limpar carrinho..")

  const bodyData = {
    action: "marvanejo_flush_carts",
    customer: CID2,
    store: 0
  }

  const formBody = new URLSearchParams(bodyData)

  fetch(ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Accept": "application/json, text/plain, */*"
    },
    body: formBody.toString()
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error(`${res.status} ${res.statusText}`)
      }

      const ct = res.headers.get("content-type") || ""
      return ct.includes("application/json") ? res.json() : res.text()
    })
    .then(console.log)
    .catch((error) => {
      console.error(error)
      showLoadingModal("Erro de comunicação! Tente novamente")
    })
    .finally(() => {
      removeLoadingModal()
      window.location.reload()
    })
}

function showNotice(text, { type = "added", duration = 5000, target } = {}) {
  document.querySelectorAll(`.${type}`).forEach(el => el.remove())

  const el = document.createElement("span")
  el.className = type
  el.textContent = ` ${text}`

  Object.assign(el.style, {
    position: "fixed",
    top: "1rem",
    right: "1rem",
    padding: "0.5rem 0.75rem",
    background: type === "error" ? "#b91c1c" : "#111827",
    color: "#fff",
    borderRadius: "4px",
    boxShadow: "0 2px 10px rgba(0,0,0,.15)",
    opacity: "0",
    transform: "translateY(-8px)",
    transition: "opacity 300ms ease, transform 300ms ease",
    zIndex: "9999",
  })

  const mountPoint = target ? document.querySelector(target) : document.body
  (mountPoint || document.body).append(el)

  requestAnimationFrame(() => {
    el.style.opacity = "1"
    el.style.transform = "translateY(0)"
  })

  setTimeout(() => {
    el.style.opacity = "0"
    el.style.transform = "translateY(-8px)"
    el.addEventListener("transitionend", () => el.remove(), { once: true })
  }, duration)

  return el
}

async function refreshHeaderCart() {
  const container = document.querySelector(".site-header__cart")
  if (!container) return

  try {
    const html = await fetch(window.location.href, { credentials: "same-origin" }).then(r => r.text())
    const doc = new DOMParser().parseFromString(html, "text/html")
    const fresh = doc.querySelector(".site-header__cart")
    if (fresh) container.replaceChildren(...fresh.children)
  } catch (err) {
    console.error("Falha ao atualizar carrinho:", err)
  }
}

function normalizeItems(items) {
  return Array.isArray(items) ? items : [items]
}

async function AddtoCart(items, target = "") {
  const payload = { items: normalizeItems(items) }

  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify(payload)
    })

    const text = await res.text()

    if (!res.ok) {
      let msg = "Não foi possível adicionar produto."

      try {
        const err = JSON.parse(text)
        if (err && err.description) {
          msg = `Não foi possível adicionar produto. ${String(err.description).replace("[PROMO]", "")}`
        }
      } catch {
        msg = `Não foi possível adicionar produto. ${text}`
      }

      showNotice(msg, { type: "error", duration: 5000, target })
      return
    }

    showNotice("Produto Adicionado", { type: "added", duration: 5000, target })
    await refreshHeaderCart()
  } catch (err) {
    console.error(err)
    showNotice("Não foi possível adicionar produto. Tente novamente.", { type: "error", duration: 5000, target })
  }
}

async function checkIfCartNeedsFlush() {
  const el = document.querySelector(".cart-products-count")

  if (!el || el.textContent.trim() === "0") return

  const flyer  = parseInt(el.dataset.flyer  ?? "0", 10) || 0
  const basket = parseInt(el.dataset.basket ?? "0", 10) || 0

  const total = basket + flyer

  if (total === 0) {
    try {
      const res = await fetch("/cart/clear.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      })

      const data = await res.json().catch(() => null)

      if (data) console.log(data)
    } catch (err) {
      console.error("Erro ao limpar o carrinho:", err)
    }
  }

  if (typeof getCartsCount === "function") {
    getCartsCount()
  }
}
